"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.V = void 0;

const checkVariantDefined = variant => {
  if (variant === null || variant === undefined) {
    throw new Error("Variant is not defined");
  }
};

const V = {
  type: function (variant) {
    checkVariantDefined(variant);
    return variant[0];
  },
  value: function (variant) {
    checkVariantDefined(variant);
    return variant[1];
  },
  valueIf: function (variant, variantType) {
    if (V.type(variant) === variantType) {
      return V.value(variant);
    } else {
      throw new Error(`Unexpected access to '${V.type(variant)}' of variant, it should be '${variantType}'`);
    }
  },
  if: (variant, variantType) => {
    if (V.type(variant) === variantType) {
      return V.value(variant);
    } else {
      return null;
    }
  },
  branch: function (variant, switchObject) {
    checkVariantDefined(variant);
    const fn = switchObject[V.type(variant)];

    if (!fn) {
      const availableKeys = Object.keys(switchObject);
      throw new Error(`type "${V.type(variant)}" is not in provided switchObject. Included types: ${availableKeys.join(", ")}`);
    }

    return fn(V.value(variant), V.type(variant));
  },
  map: (variant, switchObject) => {
    checkVariantDefined(variant);

    if (!switchObject[V.type(variant)]) {
      const availableKeys = Object.keys(switchObject);
      throw new Error(`type "${V.type(variant)}" is not in provided switchObject. Included types: ${availableKeys.join(", ")}`);
    }

    return [V.type(variant), switchObject[V.type(variant)](V.value(variant), V.type(variant))];
  },
  extract: collection => {
    if (Array.isArray(collection)) {
      const res = {};
      collection.forEach(variant => {
        const type = V.type(variant);

        if (!res[type]) {
          res[type] = [];
        }

        res[type].push(V.value(variant));
      });
      return res;
    } else if (typeof collection === "object") {
      const res = {};
      Object.keys(collection).forEach(key => {
        const variant = collection[key];
        const type = V.type(variant);

        if (!res[type]) {
          res[type] = {};
        }

        res[type][key] = V.value(variant);
      });
      return res;
    } else {
      throw new Error("type is not supported");
    }
  }
};
exports.V = V;
//# sourceMappingURL=variant.js.map